export default __webpack_public_path__ + "static/media/real-estate-banner.66ff3cc7.svg";